import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiGitlab,
  SiGithub,
  SiDocker,
  SiAmazonaws,
  SiMicrosoftazure,
  SiPostman,
  SiOpenai,
  SiJupyter,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiGitlab />
        <div className="tech-icons-text">GitLab</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <SiGithub />
        <div className="tech-icons-text">GitHub</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <SiDocker />
        <div className="tech-icons-text">Docker</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <SiAmazonaws />
        <div className="tech-icons-text">AWS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <SiMicrosoftazure />
        <div className="tech-icons-text">Azure</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <SiPostman />
        <div className="tech-icons-text">Postman</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <SiOpenai />
        <div className="tech-icons-text">OpenAI</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <SiJupyter />
        <div className="tech-icons-text">Jupyter Notebook</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
